import { CampaignDto } from '@shared/services/apiService';
import { CampaignRunStatusType } from '@shared/services/apiService/missing-types';
import { CampaignStatus } from './CampaignStatusButton';

type CampaignForStatus = { status?: CampaignDto['status'] | null } | null | undefined;

export const getCampaignStatus = (campaign: CampaignForStatus): CampaignStatus => {
  const status = campaign?.status as string | undefined;
  if (status === CampaignRunStatusType.ACTIVE || status === 'finishing') {
    return CampaignStatus.Dialing;
  }
  return CampaignStatus.NotStarted;
};

export const formatCampaignStatusLabel = (status?: string | null): string => {
  if (!status || status === 'inactive') return 'Inactive';
  if (status === 'finishing') return 'Finishing';
  if (status === 'active') return 'Active';
  return status.charAt(0).toUpperCase() + status.slice(1);
};
